import { createFileRoute } from '@tanstack/react-router';
import { CrmPreviewPage } from '@/pages/Crm/CrmPreviewPage';
import { AclRoute, withPermission } from '@/lib/acl';
import { crmNavItem } from '@/lib/crm/crm-nav';

function Preview() {
  return <CrmPreviewPage navId="catalog" />;
}

export const Route = createFileRoute('/crm/catalog')({
  component: withPermission(Preview, { key: crmNavItem('catalog').access, route: AclRoute.CRM, resourceLabel: 'Service catalog' }),
});
